export function round(value: number, fragment = 2): number {
  const shared = 10 ** fragment
  return Math.round(value * shared) / shared
}

export function floor(value: number, fragment = 2): number {
  const shared = 10 ** fragment
  return Math.floor(value * shared) / shared
}

export function growthPercentage(target: number, source: number, fragment = 2): number {
  return source === 0 ? 0 : round((100 * (target - source)) / source, fragment)
}
